<template>
  <div class="d-flex">
    <div class="side-frame"></div>
    <div>
      <span style="font-size: 14px; color: #606266">
        {{ $l('process_sheet_group_title_production_process') || '生产工序' }}
      </span>
      <el-divider v-if="!disabled" direction="vertical"></el-divider>
      <b-button
        v-if="!disabled"
        size="sm"
        class="mr-2"
        variant="outline-success"
        @click="$emit('openEditDialog', { type: 'add' })"
      >
        {{ $l('INDEX.btn_add') || '新增' }}
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    disabled: { type: Boolean, default: false }
  }
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 5px;
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 5px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 5px;
}
.side-frame-danger {
  padding: 1px 5px;
  border-left: 3px solid $color-danger;
  height: 20px;
  margin-top: 5px;
}
</style>
